import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=13fef2b8&"
import script from "./ChatContact.vue?vue&type=script&lang=js&"
export * from "./ChatContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fef2b8')) {
      api.createRecord('13fef2b8', component.options)
    } else {
      api.reload('13fef2b8', component.options)
    }
    module.hot.accept("./ChatContact.vue?vue&type=template&id=13fef2b8&", function () {
      api.rerender('13fef2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/chat/ChatContact.vue"
export default component.exports